import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface RawResult {
  updateMe: boolean;
}

export type Args = {
  userId: string;
  loginId?: string;
  name?: string;
  email?: string;
};

export const updateMe = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const { userId, loginId, name, email } = args;
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      userId,
      loginId,
      name,
      email
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
